import { useEffect } from "react";

// react-router-dom components
import { useLocation } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";
import { useMaterialUIController, setLayout } from "../../context";
import MaterialBox from "../../components/MaterialBox";
import DashboardFooter from "./components/Footer";
import DashboardNavbar from "./components/Navbar";
import { Box } from "@mui/material";

function DashboardLayout({ children, isCheckedIn, onClick }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;
  const { pathname } = useLocation();

  useEffect(() => {
    setLayout(dispatch, "dashboard");
  }, [pathname]);

  return (
    <>
      <MaterialBox
        sx={({ breakpoints, transitions, functions: { pxToRem } }) => ({
          // p: 3,
          position: "relative",

          [breakpoints.up("xl")]: {
            marginLeft: miniSidenav ? pxToRem(100) : pxToRem(260),
            transition: transitions.create(["margin-left", "margin-right"], {
              easing: transitions.easing.easeInOut,
              duration: transitions.duration.standard,
            }),
          },
        })}
      >
        <DashboardNavbar onClick={onClick} isCheckedIn={isCheckedIn} />
        <div style={{ marginTop: "2%", marginRight:'1%' }}>{children}</div>
      </MaterialBox>
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          right: 0,
          // padding: "10px",
          width: "100%",
        }}
      >
        <DashboardFooter />
      </Box>
    </>
  );
}

// Typechecking props for the DashboardLayout
DashboardLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardLayout;